module.exports = __webpack_public_path__ + "static/media/oneGlass.75c9d4ba.jpg";